/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/


import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import { Container } from '@mui/material';


const styles = makeStyles(theme => ({
    root: {
    },
    cardContent: {
        margin: '20px',
    },
    imageDotedDescp: {
        transition: 'transform .2s',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        "&:hover": {
            transform: 'scale(1.2)',

        }
    },
    sectionTitleBorder: {
        width: '50px',
        height: '2px',
        marginRight: 'auto',
        marginLeft: 'auto',
        backgroundColor: '#fb743e',

    },
    divinfoNavigation: {
        marginTop: '100px'
    },
    blocksTypoInfo: {
        lineHeight: "2.5em!important"
    },
    socialIconsList: {
        background: '#0b0b1e6e!important',
        paddingBottom: '30px!important'

    }
}));


const Contactus = () => {
    const classes = styles();

    return (
        <>

            <Grid container spacing={4}>

                <Grid item xs={12} sm={12} md={12}  >
                    <div >
                        <Typography variant="h1" align="center" style={{ marginTop: '100px', marginBottom: '20px' }} paragraph>
                            Contact Us
                        </Typography>
                        <div className={classes.sectionTitleBorder}></div>
                        <div className={classes.divinfoNavigation}>

                            <Container className={classes.cardGrid} maxWidth="lg">

                            </Container>

                        </div>
                    </div>
                </Grid>

            </Grid>

        </>
    );
}



export default Contactus;